//Base imports
import { createSlice, PayloadAction, Slice, CaseReducerActions, SliceCaseReducers, AnyAction } from '@reduxjs/toolkit';
import { Reducer } from 'react';
import { RootState, AppThunk } from '.';

//Custom imports
import { ISPFRRService, SPFRRService } from '@services/proyecta/spfrr.service';
import { IDtoSPFrrHeader } from '@models/*';
import { Utilities } from '@utils';

export interface ISpfrrState {
    currentHeaderBudget?: IDtoSPFrrHeader;
}

export class SPFRRStore {
    COMPLETE_TASK_DISPATCH = "session/addCompleteThread";

    reducer: Reducer<any, AnyAction>;
    service: ISPFRRService;
    initialState: ISpfrrState;
    slice: Slice;
    actions: CaseReducerActions<SliceCaseReducers<any>>;

    //selectors
    selectCurrentBudgetHeader: any;

    constructor() {
        this.service = new SPFRRService();
        this.initialState = this.initializeState();

        this.slice = createSlice({
            name: 'spfrr',
            initialState: this.initialState,
            reducers: this.initializeReducers()
        });

        //create properties to context - redux actions & redux reducer
        this.actions = this.slice.actions;
        this.reducer = this.slice.reducer;

        //initialize selectors
        this.selectCurrentBudgetHeader = (state: RootState) => state.spfrr.currentHeaderBudget;
    }

    //#region Public methods
    public getBudgetHeader = (budgetId: number): AppThunk => (dispatch, getState) => {
        const lang = getState().session.lang;
        this.service.getHeader({ budgetId: budgetId, langLabel: lang.label })
            .then((formMaster: any) => {
                dispatch(this.actions.setCurrentBudgetHeader(formMaster));
            })
            .catch(err => Utilities.writeInConsoleLog(err));
    }
    //#endregion

    //#region Privated methods
    private initializeReducers(): any {
        return {
            setCurrentBudgetHeader: (state: ISpfrrState, action: PayloadAction<any>) => {
                state.currentHeaderBudget = action.payload;
            }
        }
    }

    private initializeState(): ISpfrrState {
        return <ISpfrrState>{
            currentHeaderBudget: null
        }
    }
    //#endregion
}